// extracted by mini-css-extract-plugin
export default {"groupedWarningTable":"groupedWarningTable-Algeq","warningGroupHeader":"warningGroupHeader-pYAjj","warnings":"warnings-cdCjG","warning":"warning-LYWGj"};